import { stringifyUrl } from 'query-string';
import { getTulipsSmartFillApiUrl } from '../selectors/getBaseUrlSelectors';

export const transformSmartfillData = (data) => {
  if (!data.locations) {
    return [];
  }
  return (
    data.locations.map((suggestion) => {
      const { id, name = '', type } = suggestion;
      return {
        ...suggestion,
        smartFillCacheId: id || `${name.replace(/\s/g, '')}${type}`,
      };
    })
  );
};

export default {
  fetch: ({ locale, query, type }, action, state) => {
    const url = stringifyUrl({
      url: `${getTulipsSmartFillApiUrl(state)}/tulips/rds-smartfill`,
      query: {
        locale,
        query,
        type,
      },
    });
    return {
      url,
      opts: {
        credentials: 'omit',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    };
  },
  idKey: 'smartFillCacheId',
  transformData: transformSmartfillData,
};
